import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/arrow-alt-circle-right': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M504 256c0 137-111 248-248 248s-248-111-248-248 111-248 248-248 248 111 248 248zM56 256c0 110.5 89.5 200 200 200s200-89.5 200-200-89.5-200-200-200-200 89.5-200 200zM128 276v-40c0-6.6 5.4-12 12-12h116v-67c0-10.7 12.9-16 20.5-8.5l99 99c4.7 4.7 4.7 12.3 0 17l-99 99c-7.6 7.6-20.5 2.2-20.5-8.5v-67h-116c-6.6 0-12-5.4-12-12z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/arrow-alt-circle-right.js
// module id = 1691
// module chunks = 0